module.exports = {
    bindings: {
        nomenclatureGroups: '<'
    },
    templateUrl: 'nomenclature/components/nomenclature-groups.html'
};